"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var ConfigurationPanelContent_1 = tslib_1.__importDefault(require("./ConfigurationPanelContent"));
var ConfigSection_1 = tslib_1.__importDefault(require("../configurationControls/ConfigSection"));
var DataLabelsControl_1 = tslib_1.__importDefault(require("../configurationControls/DataLabelsControl"));
var bubble_1 = require("../../constants/bubble");
var PieChartConfigurationPanel = /** @class */ (function (_super) {
    tslib_1.__extends(PieChartConfigurationPanel, _super);
    function PieChartConfigurationPanel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PieChartConfigurationPanel.prototype.renderConfigurationPanel = function () {
        var _a = this.props, propertiesMeta = _a.propertiesMeta, properties = _a.properties, pushData = _a.pushData;
        var controlsDisabled = this.isControlDisabled();
        return (react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { showDelay: bubble_1.SHOW_DELAY_DEFAULT, hideDelay: bubble_1.HIDE_DELAY_DEFAULT },
            react_1.default.createElement("div", null,
                this.renderColorSection(),
                this.renderLegendSection(),
                react_1.default.createElement(ConfigSection_1.default, { id: "canvas_section", title: "properties.canvas.title", propertiesMeta: propertiesMeta, properties: properties, pushData: pushData },
                    react_1.default.createElement(DataLabelsControl_1.default, { pushData: pushData, properties: properties, isDisabled: controlsDisabled, defaultValue: false }))),
            react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: this.getBubbleClassNames(), arrowOffsets: { "tc bc": [bubble_1.BUBBLE_ARROW_OFFSET_X, bubble_1.BUBBLE_ARROW_OFFSET_Y] }, alignPoints: [{ align: "tc bc" }] },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "properties.config.not_applicable" }))));
    };
    PieChartConfigurationPanel.prototype.getBubbleClassNames = function () {
        return classnames_1.default("bubble-primary", {
            invisible: !this.isControlDisabled(),
        });
    };
    return PieChartConfigurationPanel;
}(ConfigurationPanelContent_1.default));
exports.default = PieChartConfigurationPanel;
//# sourceMappingURL=PieChartConfigurationPanel.js.map